import type { ReactElement } from "react";

import { LocationDropdown } from "app/pages/sales-intelligence/common-components/dropdown/LocationDropdown";
import { ZipCodeInput } from "app/pages/sales-intelligence/common-components/zip-codes/components/ZipCodeInput/ZipCodeInput";
import InclusionGroup from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/atoms/InclusionGroup";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import {
    ZIP_CODES_BULK_TRANSLATION_PREFIX,
    ZIP_CODES_PLACEHOLDER,
} from "app/pages/sales-intelligence/modules/leads-search-filters/components/filters/CompanyHeadquarterFilter/const";
import { FilterContentContainer } from "app/pages/sales-intelligence/modules/leads-search-filters/components/filters/styles";

import type FindCompanyHeadquarterFilter from "../../../models/CompanyHeadquarterFilter/CompanyHeadquarterFilter";

import { StatesDropdown } from "./components/StatesDropdown";
import useCompanyHeadquarterFilter from "./hooks/useCompanyHeadquarterFilter";

const CompanyHeadquarterFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindCompanyHeadquarterFilter>): ReactElement | null => {
    const {
        inclusionValue,
        regions,
        countries,
        isSingleCountrySelected,
        isUSSelected,
        states,
        handleInclusionSelection,
        handleLocationChange,
        handleStateSelection,
        handleZipCodeBulkAdd,
        handleZipCodeAdd,
    } = useCompanyHeadquarterFilter({ filter, value, onFilterUpdate });

    return (
        <FilterContentContainer>
            <InclusionGroup
                value={inclusionValue}
                onChange={handleInclusionSelection}
            />

            <LocationDropdown
                regions={regions}
                countries={countries}
                value={value}
                onChange={handleLocationChange}
                dataAutomation="headquarters-countries-dropdown"
            />

            {isUSSelected ? (
                <StatesDropdown
                    states={states}
                    value={value}
                    onSelect={handleStateSelection}
                />
            ) : null}

            {isSingleCountrySelected ? (
                <ZipCodeInput
                    placeholderTranslation={ZIP_CODES_PLACEHOLDER}
                    bulkTranslationPrefix={ZIP_CODES_BULK_TRANSLATION_PREFIX}
                    onAdd={handleZipCodeAdd}
                    onBulkAdd={handleZipCodeBulkAdd}
                />
            ) : null}
        </FilterContentContainer>
    );
};

export default CompanyHeadquarterFilter;
